<template>
  <button
    class='lt-fyf-question_answer'
    @click='onSelect'
  >
    <div class='lt-fyf-question_answer_text'>
      <span class="lt-fyf-question_answer_title">
        {{ title }}
      </span>
      <p
        class="lt-fyf-question_answer_lifestyle"
        v-if="lifestyle"
      >
        {{ lifestyle }}
      </p>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '~~~~',
    },
    lifestyle: {
      type: String,
      default: '',
    },
    /* eslint-disable vue/require-default-prop */
    onSelect: {
      type: Function,
    },
    /* eslint-enable vue/require-default-prop */
  },
};
</script>

<style lang='scss'>

$mobile-bp: 650px;

@mixin hover-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  opacity: 0;
}

.lt-fyf-question_answer {
  position: relative;
  appearance: none;
  flex: 1;
  background-color: white;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border: 0 none;
  border-radius: 3px;
  margin: 0.375rem 0.75rem;
  box-shadow: $q-a-shadow;
  cursor: pointer;


  &::after {
    content: '';
    @include hover-bg;
  }

  &:hover {
    &::after, .lt-fyf-question_answer_text::before {
      opacity: .1;
    }
  }

  &:nth-child(2) .lt-fyf-question_answer_text {
    background: $answer-b-background;
  }
  &:nth-child(3) .lt-fyf-question_answer_text {
    background: $answer-c-background;
  }
  @include breakpoint-landscape {
    @include scut-ratio-box(2/1);
    overflow: visible;
  }
  @include breakpoint-portrait {
    flex-direction: column;
    border-radius: 0;
    margin: 0.625rem 3.75rem;
    @include breakpoint-mobile {
      margin: 2.5rem 3.75rem;
      max-height: 135px;
    }
    @media (min-width: 48.125em) {
      max-height: 380px;
    }
  }

}

.lt-fyf-question_answer_text {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  justify-content: center;
  position: relative;
  padding: .5rem 1rem;
  bottom: 0;
  transform: translate(0, 50%);
  color: white;
  background: $answer-a-background;
  font-size: 1.2rem;
  border-radius: 3px;
  max-width: 100%;
  box-shadow: $q-a-shadow;
  z-index: 4;
  align-items: center;
  &::before {
    content: '';
    @include hover-bg;
  }
  &--no-min-height { // TODO - apply to co-habiting question
    min-height: 0;
  }

  @include breakpoint-landscape {
    height: 0; // for ie11
    min-height: 100px;
  }

  @include breakpoint-portrait {
    position: absolute;
    left: 0;
    right: 0;
    transform: translate(0, 0);
    padding: 0.5rem 0.75rem;
    font-size: 1.3rem;
    border-radius: 0;
    margin: 0.675rem;
    padding: 1rem;
    @include breakpoint-mobile {
      font-size: 0.8rem;
      transform: translate(0, 100%);
      padding: 1rem 0.75rem;
      margin: 0;
    }
  }

}

.lt-fyf-question_answer_lifestyle {
  margin-top: .5rem;
  margin-bottom: 0;
  font-size: .75rem;
  font-weight: bold;
  text-transform: uppercase; 
  letter-spacing: 1px;
  color: #ffabae;
}
.lt-fyf-question_answer_title {
  flex-direction: column;
  display: block;
  width: 100%; // for ie11
}

</style>
